//$(document).ready(function(){
  

//   $(".slider-cstm").slick({
//     autoplay: false,
//     dots: true,
//     arrows: false,
//     customPaging : function(slider, i) {
//     var thumb = $(slider.$slides[i]).data();
//         let get_cur_thum = i+1;
//     return '<a class="dot">'+get_cur_thum+'</a>';
//             },
//     responsive: [
//     {
//       breakpoint: 500,
//       settings: {
//       slidesToShow: 1,
//       slidesToScroll: 1
        
//       }
//     }
//   ]    
// });




//})


 document.addEventListener('click', function (e) {
    const btn = e.target.closest('.hamburger-menu');
    if (!btn) return;

    const isActive = document.body.classList.toggle('menu-overflow-hidden');
    // optional: update accessibility state
    btn.setAttribute('aria-expanded', isActive);
  });

  // Optional: ESC press par band
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.body.classList.remove('menu-overflow-hidden');
      document.querySelectorAll('.hamburger-menu')
        .forEach(b => b.setAttribute('aria-expanded', 'false'));
    }
  });


